import React from "react";

import Step from "../../../../../../atoms/Wizard/Step";
import ProductAddedList from "../../../ProductAddedList";
import SearchWithComponents from "../../../../../../atoms/Filters/SearchWithComponents";
import trashIcon from "assets/images/trash-icon.svg";

import styles from "./Step2.module.scss";
import i18n from "i18n";

export const RequestOrderStep2 = ({ resultList, searchValue, handleChange, products, totalProducts, goBackFunc, handleSelectToAddProduct, handleSelectedProductQuantityChange,
  handleAdd, handleAddProduct, handleDeleteAddedProduct, selectedProducts, changePage, pagination, handleSelectOutOfStock, outOfStockSelected}) => {

    const stepContent = (
        <div className={styles["request-order-step-two-content"]}>
          <div className={styles["request-order-step-two-field"]} data-automation-id="input-search">
            <SearchWithComponents
              placeholder = {i18n.t("search.by.name.or.code")}
              resultList = {resultList}
              value = {searchValue}
              handleChange={handleChange}
              handleSelectToAddProduct={handleSelectToAddProduct} handleSelectedProductQuantityChange={handleSelectedProductQuantityChange} handleAdd={handleAdd}
              selectedProducts={selectedProducts}
              onlyStockHidden={true}
            />

            {products.length > 0 && <ProductAddedList total={totalProducts} products={products} edit={true} handleEdit={handleAddProduct} handleDelete={handleDeleteAddedProduct}
              changePage={changePage}
              pagination={pagination}
              trashIcon={<img src={trashIcon} draggable={false} />}
            ></ProductAddedList>}
          </div>
        </div>
      );
    return (
        <div className={styles["request-order-step-two-container"]}>
          <Step goBackFunc={goBackFunc} title={i18n.t("what.products.want.replenish")} content={stepContent}></Step>
        </div>
      );
}

export default RequestOrderStep2